import { render, staticRenderFns } from "./CustomButton.vue?vue&type=template&id=bf20794a&scoped=true&"
import script from "./CustomButton.vue?vue&type=script&lang=ts&"
export * from "./CustomButton.vue?vue&type=script&lang=ts&"
import style0 from "./CustomButton.vue?vue&type=style&index=0&id=bf20794a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf20794a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
